"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.URI = void 0;
var URI;
(function (URI) {
    /* PUBLIC FUNCTIONS */
    function getQuery(prefix) {
        const query = _getQuery();
        if (prefix)
            return getPrefix(prefix, query);
        return query;
    }
    URI.getQuery = getQuery;
    function getQueryParam(param, prefix) {
        if (prefix)
            return _getQuery()[formatPrefix(prefix, param)];
        return _getQuery()[param];
    }
    URI.getQueryParam = getQueryParam;
    function setQuery(query, prefix) {
        if (prefix)
            return _setQuery(addPrefix(prefix, query));
        return _setQuery(query);
    }
    URI.setQuery = setQuery;
    function addQuery(query, prefix) {
        if (prefix)
            return _addQuery(addPrefix(prefix, query));
        return _addQuery(query);
    }
    URI.addQuery = addQuery;
    function addQueryParam(param, value, prefix) {
        if (prefix)
            return _addQuery({ [formatPrefix(prefix, param)]: value });
        return _addQuery({ [param]: value });
    }
    URI.addQueryParam = addQueryParam;
    function removeQuery(prefix) {
        if (prefix)
            return _setQuery(removePrefix(prefix, _getQuery()));
        return _removeQuery();
    }
    URI.removeQuery = removeQuery;
    function removeQueryParam(param, prefix) {
        if (prefix)
            return _removeQueryParam(formatPrefix(prefix, param));
        return _removeQueryParam(param);
    }
    URI.removeQueryParam = removeQueryParam;
    function getHash(prefix) {
        const hash = _getQuery();
        if (prefix)
            return getPrefix(prefix, hash);
        return hash;
    }
    URI.getHash = getHash;
    function getHashParam(param, prefix) {
        if (prefix)
            return _getHash()[formatPrefix(prefix, param)];
        return _getHash()[param];
    }
    URI.getHashParam = getHashParam;
    function setHash(hash, prefix) {
        if (prefix)
            return _setHash(addPrefix(prefix, hash));
        return _setHash(hash);
    }
    URI.setHash = setHash;
    function addHash(hash, prefix) {
        if (prefix)
            return _addHash(addPrefix(prefix, hash));
        return _addHash(hash);
    }
    URI.addHash = addHash;
    function addHashParam(param, value, prefix) {
        if (prefix)
            return _addHash({ [formatPrefix(prefix, param)]: value });
        return _addHash({ [param]: value });
    }
    URI.addHashParam = addHashParam;
    function removeHash(prefix) {
        if (prefix)
            return _setQuery(removePrefix(prefix, _getQuery()));
        return _removeHash();
    }
    URI.removeHash = removeHash;
    function removeHashParam(param, prefix) {
        if (prefix)
            return _removeHashParam(formatPrefix(prefix, param));
        return _removeHashParam(param);
    }
    URI.removeHashParam = removeHashParam;
    function onHashChange(listener) {
        if (typeof window != 'undefined') {
            let oldHref = document.location.href;
            const bodyList = document.querySelector("body");
            const observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    if (oldHref !== document.location.href) {
                        oldHref = document.location.href;
                        const hash = _getHash();
                        listener && listener(hash);
                    }
                });
            });
            var config = {
                childList: true,
                subtree: true
            };
            observer.observe(bodyList, config);
            return observer.disconnect;
        }
    }
    URI.onHashChange = onHashChange;
    function onQueryChange(listener) {
        if (typeof window != 'undefined') {
            let oldHref = document.location.href;
            const bodyList = document.querySelector("body");
            const observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    if (oldHref !== document.location.href) {
                        oldHref = document.location.href;
                        const query = _getQuery();
                        listener && listener(query);
                    }
                });
            });
            var config = {
                childList: true,
                subtree: true
            };
            observer.observe(bodyList, config);
            return observer.disconnect;
        }
    }
    URI.onQueryChange = onQueryChange;
    function removeAll(prefix) {
        if (prefix) {
            _setQuery(removePrefix(prefix, _getQuery()));
            _setHash(removePrefix(prefix, _getHash()));
        }
        _removeQuery();
        _removeHash();
    }
    URI.removeAll = removeAll;
    /* PRIVATE */
    function formatPrefix(prefix, key = '') {
        return `${prefix}.${key}`;
    }
    function removePrefix(prefix, query) {
        const result = {};
        const keys = Object.keys(query);
        for (const key of keys) {
            if (!key.startsWith(formatPrefix(prefix)))
                result[key] = query[key];
        }
        return result;
    }
    function addPrefix(prefix, query) {
        const result = {};
        const keys = Object.keys(query);
        for (const key of keys) {
            result[formatPrefix(prefix, key)] = query[key];
        }
        return result;
    }
    function getPrefix(prefix, query) {
        const result = {};
        const keys = Object.keys(query);
        for (const key of keys) {
            if (key.startsWith(formatPrefix(prefix))) {
                const realKey = key.replace(formatPrefix(prefix), '');
                result[realKey] = query[key];
            }
        }
        return result;
    }
    function _getQuery() {
        if (typeof window != 'undefined')
            return Object.fromEntries(new URLSearchParams(window.location.search?.substring(1)));
        return {};
    }
    function _setQuery(query) {
        if (!query)
            query = {};
        if (typeof window != 'undefined') {
            const newUrl = `${window.location.origin}${window.location.pathname}?${new URLSearchParams(query).toString()}${window.location.hash}`;
            window.history.replaceState({ path: newUrl }, '', newUrl);
        }
    }
    function _addQuery(query) {
        if (!query)
            query = {};
        _setQuery({ ..._getQuery(), ...query });
    }
    function _removeQuery() {
        _setQuery(null);
    }
    function _removeQueryParam(key) {
        const query = _getQuery();
        delete query[key];
        _setQuery(query);
    }
    function _getHash() {
        if (typeof window != 'undefined')
            return Object.fromEntries(new URLSearchParams(window.location.hash?.substring(1)));
        return {};
    }
    function _setHash(hash) {
        if (!hash)
            hash = {};
        if (typeof window != 'undefined') {
            const newUrl = `${window.location.origin}${window.location.pathname}${window.location.search}#${new URLSearchParams(hash).toString()}`;
            window.history.replaceState({ path: newUrl }, '', newUrl);
        }
    }
    function _addHash(hash) {
        if (!hash)
            hash = {};
        _setHash({ ..._getHash(), ...hash });
    }
    function _removeHash() {
        _setHash(null);
    }
    function _removeHashParam(key) {
        const query = _getHash();
        delete query[key];
        _setHash(query);
    }
})(URI = exports.URI || (exports.URI = {}));
exports.default = URI;
